<div class="root" *transloco="let t; read:'permit'">
    <ng-container *ngIf="hasError">
        <div class="root__error">{{ t("handleFlammableAtexPermitRequest.error") }}</div>
        <button class="root__button" type="button" (click)="openRequestList()">
            {{ t("handleFlammableAtexPermitRequest.openRequestList") }}
        </button>
    </ng-container>
</div>
